import { TripTrackingTrigger } from "@src/app/locationTracking/locationTracking.types";
import {
  RadarTrackingOptions,
  RadarTrackingOptionsForegroundService,
  RadarTripOptions,
} from "capacitor-radar";

export enum LocationTrackingModeEnum {
  stop = "stop",
  passive = "passive",
  aggressive = "aggressive",
  onsite = "onsite",
}

export enum TravelMode {
  car = "car",
}

export enum DestinationGeofenceTag {
  facility = "Facility",
}

export interface TripOptions extends RadarTripOptions {
  metadata: {
    shiftId: string;
    shiftStart: string;
    trigger?: TripTrackingTrigger;
    platform?: string;
    appVersion?: string;
    trackingMode?: LocationTrackingModeEnum;
  };
}

export interface LocationTrackingMode {
  mode: LocationTrackingModeEnum;
  tripOptions?: TripOptions;
  trackingOptions?: RadarTrackingOptions & {
    foregroundService: RadarTrackingOptionsForegroundService;
  };
  shiftId?: string;
}

export enum StartTrackingResultReason {
  TRACKING_STARTED = "Tracking started",
  NOT_IN_TRIAL = "Not in trial",
  TRACKING_ALREADY_STARTED = "Tracking already started",
  ERROR = "Error",
}

export interface StartHyperTrackShiftResponse {
  isSuccess: boolean;
  reason?: StartTrackingResultReason;
}
